import KeyValuePair from '../key-value-pair'

export default class ScriptTagSettings {
  public source = ''
  public attributes: Array<KeyValuePair<string, string>> = []
  public body = ''
}
